import { render, staticRenderFns } from "./HomeHowItWorks.vue?vue&type=template&id=3c0884a3&scoped=true"
import script from "./HomeHowItWorks.vue?vue&type=script&lang=js"
export * from "./HomeHowItWorks.vue?vue&type=script&lang=js"
import style0 from "./HomeHowItWorks.vue?vue&type=style&index=0&id=3c0884a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0884a3",
  null
  
)

export default component.exports